<template>
  <!-- <div v-if='isLogged'> -->

    <header class="ios">
      <ion-toolbar class="header">
        <ion-img :src="item.src" class="logo" slot="start"></ion-img>
        <MenuMain/>

        <!-- IF MOBILE -->
        <router-link class="btn-profile" :to="{ name: 'profileHome'}" v-if="isMobile" slot="end">
        <!-- <router-link class="btn-profile" to="/admin/profile" slot="end" v-if="isMobile"> -->
          <div class="back"></div>
          <div class="initial">
            {{initial}}
          </div>
        </router-link>
        <!-- IF MOBILE -->

        <!-- IF DESKTOP -->
        <button class="btn-profile" v-b-toggle.sidebar-profile  slot="end" v-else>
          <div class="back"></div>
          <div class="initial">
            {{initial}}
          </div>
        </button>
        <!-- IF DESKTOP -->
  
  
  
        <!-- IF MOBILE -->
        <router-link class="notifications" :to="{ name: 'notificationsHome'}" :class="{some:notifications}" slot="end" v-if="isMobile">
          <i class="far fa-bell"></i>
          <span>{{notifications}}</span>
        </router-link>
        <!-- IF MOBILE -->

        <!-- IF DESKTOP -->
        <button class="notifications" v-b-toggle.sidebar-notifications  :class="{some:notifications}" slot="end" v-else>
          <i class="far fa-bell"></i>
          <span>{{notifications}}</span>
        </button>
        <!-- IF DESKTOP -->


      </ion-toolbar>
    



    <b-sidebar id="sidebar-profile" right shadow backdrop no-header width="360px" v-if="!isMobile">
      <ProfileHome></ProfileHome>
    </b-sidebar>


    <b-sidebar id="sidebar-notifications" right shadow backdrop no-header width="360px" v-if="!isMobile">
      <NotificationsHome></NotificationsHome>
    </b-sidebar>
    </header>

</template>

<script>
import MenuMain from './menu/MenuMain'
import { mapGetters } from 'vuex'
import utils from '../Utils'
import ProfileHome from '../../components/pages/sub_category/profile/ProfileHome'
import NotificationsHome from '../../components/pages/sub_category/notifications/NotificationsHome'

export default {
  name: "Navbar",
  components:{
    MenuMain,
    ProfileHome,
    NotificationsHome    
  },
  data(){
    return {
      item:{
        src:'/img/logo.svg'
      },
      notifications:null,
      isLogged:false,
      isMobile:false,
    }
  },
  computed: {
    ...mapGetters([
      'getNotifications',
      'getAuthenticated',
      'getInitial'
    ])
  },
  created (){
    this.isLogged = this.getAuthenticated;
    this.notifications = this.getNotifications;
    this.initial = this.getInitial;
    this.isMobile = utils.isMobile();
  },  
  methods: {
    incrementNotifications: function (){
      this.$store.dispatch('incrementNotifications')
    },
    disconnect: function (){
      this.$store.dispatch('disconnect');
    },
    openSlideOut:function (){
    console.log('OPEN SLIDEOUT');
      
    }
  },
  watch: {
      getNotifications() {
        this.notifications = this.getNotifications;
      },
      getAuthenticated() {
        this.isLogged = this.getAuthenticated;
      },
  }
}
</script>